export default __webpack_public_path__ + "static/media/nifty-momentum-Banner.60f0e180.png";